module.exports = __webpack_public_path__ + "img/Classifier4.5561dc60.png";